import React from "react";
import { useState } from "react";
import { Spinner } from "react-bootstrap";
import { PiExportBold } from "react-icons/pi";
import { Link } from "react-router-dom";
import Reportselect from "./Reportselect";
import Pagination from "../Constant/Pagination";
import Select from "react-select";
import { useEffect } from "react";
import format from "date-fns/format";
import { dateRangeOptions } from "../../utilities";
import DebounceSearchInput from "../Constant/DebounceSearchInput";
import { CancelRequest } from "../../services/AxiosInstance";
import DatePicker from "react-datepicker";
import {
  getReplaceLog,
  getReplaceLogExport,
} from "../../services/Reportservice";
import {
  addDays,
  subDays,
  startOfMonth,
  endOfMonth,
  subMonths,
} from "date-fns";
const statusOption = [
  { label: "In Progress", value: "In Progress" },
  { label: "Completed", value: "Completed" },
  { label: "Cancelled", value: "Cancelled" },
];
const ReplaceTypeOption = [
  { label: "Maintenance", value: "Maintenance" },
  { label: "Breakdown", value: "Breakdown" },
  { label: "Other", value: "Other" },
];
const ReplaceLog = () => {
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [selectedOption, setSelectedOption] = useState(dateRangeOptions[1]);
  const [exportloading, setExportloading] = useState(false);
  const [data, setData] = useState([]);
  const [error, setError] = useState("");
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [selectedReportType, setSelectedReportType] = useState(null);
  const [param, setParam] = useState({
    page: "1",
    page_size: "10",
    start_date: format(subDays(new Date(), 7), "yyyy-MM-dd"),
    end_date: format(new Date(), "yyyy-MM-dd"),
    query: "",
    status: "",
    repair_type: "",
  });
  const getReport = () => {
    setLoading(true);
    getReplaceLog(param)
      .then((res) => {
        setData(res?.data?.results || []);
        setTotal(res?.data?.count || 0);
        setError("");
      })
      .catch((err) => {
        setError(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      })
      .finally(() => {
        setLoading(false);
      });
  };
  useEffect(() => {
    getReport();
  }, [param]);
  const handleexport = () => {
    setExportloading(true);
    const newparam = { ...param, export: true };
    getReplaceLogExport(newparam)
      .then((res) => {
        const blob = new Blob([res.data], { type: "application/pdf" });
        const url = window.URL.createObjectURL(blob);

        const a = document.createElement("a");
        a.href = url;
        a.download = "Bus Replace-log.xlsx"; // set your desired filename
        a.click();

        window.URL.revokeObjectURL(url); // clean up
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setExportloading(false);
      });
  };
  const handlePageChange = (page) => {
    setParam((prev) => ({
      ...prev,
      page: page.selected + 1,
    }));
  };
  const handleSelectChange = (option) => {
    setSelectedOption(option);
    if (!option) {
      setParam({ ...param, start_date: "", end_date: "", page: "1" });
      return;
    }
    let startDate,
      endDate = new Date();
    switch (option.value) {
      case "yesterday":
        startDate = subDays(new Date(), 1);
        endDate = startDate;
        break;
      case "7_days":
        startDate = subDays(new Date(), 7);
        break;
      case "15_days":
        startDate = subDays(new Date(), 15);
        break;
      case "30_days":
        startDate = subDays(new Date(), 30);
        break;
      case "last_month":
        startDate = startOfMonth(subMonths(new Date(), 1));
        endDate = endOfMonth(subMonths(new Date(), 1));
        break;
      case "3_months":
        startDate = startOfMonth(subMonths(new Date(), 3));
        endDate = endOfMonth(subMonths(new Date(), 1));
        break;
      case "custom":
        setShowDatePicker(true);
        return;
      default:
        return;
    }
    setShowDatePicker(false);
    setParam({
      ...param,
      start_date: format(startDate, "yyyy-MM-dd"),
      end_date: format(endDate, "yyyy-MM-dd"),
      page: "1",
    });
  };
  const handleSearchChange = (value) => {
    if (value.length > 0) CancelRequest();
    setParam((prev) => ({
      ...prev,
      query: value,
      page: "1",
    }));
  };
  useEffect(() => {
    setParam({
      ...param,
      page: 1,
      status: selectedStatus?.value || "",
      repair_type: selectedReportType?.value || "",
    });
  }, [selectedStatus, selectedReportType]);
  return (
    <>
      <div className="row mb-3">
        <div className="col d-flex flex-column flex-md-row justify-content-between">
          <div>
            <span
              className="text-primary"
              style={{ fontSize: "1.3rem", fontWeight: "500" }}
            >
              Bus Replace Log
            </span>
            <ol className="breadcrumb breadcrumb-arrow mb-0">
              <li className="breadcrumb-item">
                <Link to="/dashboard">Dashboard</Link>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                Report
              </li>
            </ol>
          </div>
          <div className="d-flex gap-2 justify-content-center align-items-center">
            <div style={{ width: "300px" }}>
              <Reportselect />
            </div>
            <button
              className="btn btn-primary d-flex align-items-center gap-1 align-self-center"
              disabled={exportloading || data.length === 0}
              onClick={handleexport}
              // style={{ height: "38px" }}
            >
              {" "}
              {exportloading ? (
                <Spinner animation="border" size="sm" />
              ) : (
                <PiExportBold size={18} />
              )}
              Export
            </button>
          </div>
        </div>
      </div>
      <div className="card">
        <div className="d-flex justify-content-between flex-column flex-md-row gap-2 px-4 py-3">
          <div className="d-flex flex-column flex-md-row gap-3">
            <div className="flex-fill flex-md-grow-0">
              <small>Search here</small>
              <DebounceSearchInput handleSearchChange={handleSearchChange} />
            </div>
            <div className="flex-fill flex-md-grow-0">
              <small>Select Status</small>
              <Select
                className="react-select"
                classNamePrefix="select"
                options={statusOption}
                value={selectedStatus}
                onChange={setSelectedStatus}
                placeholder="Select Status"
                isClearable
                styles={{
                  menu: (provided) => ({
                    ...provided,
                    zIndex: 999,
                  }),
                }}
              />
            </div>
            <div className="flex-fill flex-md-grow-0">
              <small>Select Type</small>
              <Select
                className="react-select"
                classNamePrefix="select"
                options={ReplaceTypeOption}
                value={selectedReportType}
                onChange={setSelectedReportType}
                placeholder="Select Type"
                isClearable
                styles={{
                  menu: (provided) => ({
                    ...provided,
                    zIndex: 999,
                  }),
                }}
              />
            </div>
          </div>
          <div className="d-flex flex-column flex-md-row gap-2">
            {showDatePicker && (
              <div className="flex-fill flex-md-grow-0">
                <small>Select Date</small>
                <DatePicker
                  selectsRange
                  startDate={
                    param?.start_date ? new Date(param.start_date) : null
                  }
                  endDate={param?.end_date ? new Date(param.end_date) : null}
                  onChange={(update) => {
                    const [start, end] = update;
                    setParam((prev) => ({
                      ...prev,
                      start_date: start ? format(start, "yyyy-MM-dd") : "",
                      end_date: end ? format(end, "yyyy-MM-dd") : "",
                      page: 1,
                    }));
                  }}
                  isClearable
                  placeholderText="Select date range"
                  className="form-control"
                  style={{
                    fontSize: "0.5rem",
                  }}
                  popperProps={{
                    modifiers: [
                      {
                        name: "zIndex",
                        enabled: true,
                        phase: "beforeWrite",
                        fn({ state }) {
                          state.styles.popper.zIndex = 999;
                        },
                      },
                    ],
                  }}
                />
              </div>
            )}
            <div className="flex-fill flex-md-grow-0">
              <small>Select Period</small>
              <Select
                options={dateRangeOptions}
                onChange={handleSelectChange}
                placeholder="Select Period"
                className="react-select"
                classNamePrefix="select"
                value={selectedOption}
                styles={{
                  menu: (provided) => ({
                    ...provided,
                    zIndex: 999,
                  }),
                }}
              />
            </div>
          </div>
        </div>
        <div className="card-body  p-0">
          {loading ? (
            <div className="text-center my-4">
              <Spinner animation="border" variant="primary" />
            </div>
          ) : error ? (
            <div className="text-center text-danger my-3">{error}</div>
          ) : data && data.length > 0 ? (
            <div className="table-responsive">
              <table className="table mb-0 align-middle fs-6">
                <thead className="table-light custom-thead">
                  <tr>
                    <th>Start Date</th>
                    <th>End Date</th>
                    <th>Route</th>
                    <th>Shift</th>
                    <th>Replacement Type</th>
                    <th>Bus</th>
                    <th>Replace Bus</th>
                    <th>Description</th>
                    <th>Action taken</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {data?.map((item) => {
                    const status = item.status?.toLowerCase();
                    const badgeClass =
                      {
                        "in progress": "badge bg-warning text-dark",
                        completed: "badge bg-success",
                        pending: "badge bg-secondary",
                        cancelled: "badge bg-danger",
                      }[status] || "badge bg-light text-dark";

                    return (
                      <tr>
                        <td>
                          {item?.replacement_start_date
                            ? format(item?.replacement_start_date, "dd MMM yyy")
                            : "N/A"}
                        </td>
                        <td>
                          {item?.replacement_end_date
                            ? format(item?.replacement_end_date, "dd MMM yyy")
                            : "N/A"}
                        </td>
                        <td>{item?.shift || "N/A"}</td>
                        <td>{item?.route || "N/A"}</td>
                        <td>{item?.replacement_type || "N/A"}</td>
                        <td>
                          <Link
                            className="fw-medium"
                            to={`/bus/${item?.bus?.id}`}
                          >
                            {item?.bus?.number_plate || "N/A"}
                          </Link>
                        </td>
                        <td>
                          <Link
                            className="fw-medium"
                            to={`/bus/${item?.bus?.id}`}
                          >
                            {item?.replaced_bus?.number_plate || "N/A"}
                          </Link>
                        </td>
                        <td>{item?.description || "N/A"}</td>
                        <td>{item?.action_taken_by?.fullname || "N/A"}</td>
                        <td>
                          <span className={badgeClass}>
                            {item?.status || "N/A"}
                          </span>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          ) : (
            <div className="my-2 text-center">There are no records found.</div>
          )}

          {!loading && data?.length > 0 && (
            <div className="border-top p-4">
              <Pagination
                currentPage={param.page}
                recordsPage={param.page_size}
                dataLength={total}
                handlePagination={handlePageChange}
              />
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default ReplaceLog;
